module.exports = __webpack_public_path__ + "static/seo-result-graph-8600979b4fc591fc59bcd4254977de19.png";